import request from '@/request/request'

/**
 * 忘记密码：主平台用户预检查通过后发送短信验证码
 * @param {} parameter
 * @returns
 */
export function sendForgotPasswordCode (parameter) {
  return request({
    url: '/e-find-user/forgotPassword/sendCode',
    method: 'post',
    data: parameter
  })
}

/**
 * 忘记密码：校验短信验证码并签发 resetTicket
 * @param {} parameter
 * @returns
 */
export function verifyForgotPasswordCode (parameter) {
  return request({
    url: '/e-find-user/forgotPassword/verifyCode',
    method: 'post',
    data: parameter
  })
}

/**
 * 忘记密码：使用 resetTicket 重置密码
 * @param {} parameter
 * @returns
 */
export function resetForgotPassword (parameter) {
  return request({
    url: '/e-find-user/forgotPassword/resetPassword',
    method: 'post',
    data: parameter
  })
}
